<ion-header>
  <ion-toolbar>
    <ion-title>Acumulado Compras</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <div [innerHTML]="text" class="colorBlack htmlContainer"></div> -->
  <div>

    <table mat-table [dataSource]="goalsAcc" class="z-depth-1 table">

      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="monto">
        <th mat-header-cell *matHeaderCellDef> Monto </th>
        <td mat-cell *matCellDef="let element"> {{element.value | currency}} </td>
      </ng-container>
    
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</ion-content>